import React from 'react';
import Icon from '../../muiComponents/Icon';

const SortIcon = props => {
    const { sortDir, isSorted } = props;

    const sortDirIcon = sortDir === 'asc' ? 'NorthOutlined' : 'SouthOutlined';
    const sortDirIconTitle =
        sortDir === 'asc' ? 'sorted_ascending' : 'sorted_descending';

    const iconName = isSorted ? sortDirIcon : 'SortOutlined';
    const iconTitle = isSorted ? sortDirIconTitle : 'sortable';

    return <Icon titleText={iconTitle} iconName={iconName} />;
};

export default SortIcon;
